import { t } from "i18next";
import DataHandlerHelper from "../../helpers/DataHandler.helper";
import SwitchComponent from "../../translation/Switch/Switch.component";
import InitLoginClientLogic from "./LoginClient.logic";

const LoginClientComponent: React.FC = () => {
    const { data, usernameRef, passwordRef, onSubmit, onChange } = InitLoginClientLogic();
    return (
        <div className="page-container" style={{display: "flex", flexDirection: "column", justifyContent: "center", minHeight: "100vh", paddingBottom: 40}}>
            <div style={{textAlign: "center", marginBottom: 40}}>
                <h1 style={{fontSize: "2.2rem", letterSpacing: 4, marginBottom: 4}}>RESET</h1>
                <p style={{fontSize: "0.75rem", opacity: 0.5, margin: 0, letterSpacing: 4}}>pilates studio</p>
            </div>

            <SwitchComponent></SwitchComponent>

            <div style={{marginTop: 24, display: "flex", flexDirection: "column", gap: 16}}>
                <div>
                    <label htmlFor="username">{`${t("Korisničko ime")}`}</label>
                    <input placeholder={`${t("Unesi korisničko ime...")}`} id="username" type={"text"} ref={usernameRef} onKeyDown={e => DataHandlerHelper.handleEnterKeyPress(e, () => passwordRef.current.focus())} value={data.username} onChange={onChange} name="username" required></input>
                </div>
                <div>
                    <label htmlFor="password">{`${t("Lozinka")}`}</label>
                    <input placeholder={`${t("Unesi lozinku...")}`} id="password" type={"text"} ref={passwordRef} onKeyDown={e => DataHandlerHelper.handleEnterKeyPress(e, onSubmit)} value={data.password} onChange={onChange} name="password" required></input>
                </div>
                <button type="button" className="btn-primary" onClick={onSubmit} style={{marginTop: 8}}>{`${t("Prijavi se")}`}</button>
            </div>
        </div>
    );
}

export default LoginClientComponent;
